// Helper function to get the selected variant ID
function getSelectedVariantId() {
  return (
    document.querySelector('.variant-option.selected')?.dataset?.variantId ||
    document.querySelector('.product-single__variants')?.value ||
    document.querySelector('form.product-single__form2')?.dataset?.variantId ||
    document.querySelector('input[name="id"]')?.value ||
    document.querySelector('[data-default-variant-id]')?.dataset?.defaultVariantId ||
    document.querySelector('[data-product-select]')?.value
  );
}

document.addEventListener("DOMContentLoaded", function () {
  // Get the add-to-cart button and the product form
  const addToCartButton = document.getElementById("add-to-cart");
  const productForm = document.querySelector("form.product-single__form2");

  if (!addToCartButton || !productForm) {
    console.warn("Required elements not found. Form interception skipped.");
    return;
  }

  // Update our reference to the new form
  const updatedProductForm = document.querySelector("form.product-single__form2");

  // for PDP ATC (main button and floating button). customizedItem is handled in product-form.liquid
  // Override the form submission - using capture: true to fire first
  // updatedProductForm.addEventListener("submit", async function (e) {
  //   console.log('PDP ATC PRODUCT FORM SUBMIT - CAPTURE PHASE')
  //   // Prevent the default form submission
  //   e.preventDefault();
  //   e.stopPropagation();
  //   e.stopImmediatePropagation(); // prevents form submit event from bubbling up to other listeners

  //   // Show the loading spinner
  //   const loader = addToCartButton.querySelector("[data-loader]");
  //   if (loader) loader.classList.remove("hide");

  //   // Get the main product ID (current product variant) - try multiple selectors to ensure we get the right one
  //   const mainId = getSelectedVariantId();
  //   let spressoPrice = null;
  //   try {
  //     if (window.useSpresso) {
  //       spressoPrice = await window.Spresso.getSpressoPrice(mainId, 'variant-id');
  //     }
  //   } catch (ignored) { }
  //   console.log('spressoPrice', spressoPrice);

  //   // If no customization or toggle is off, proceed with normal form submission
  //   fetch("/cart/add.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     },
  //     body: JSON.stringify({
  //       items: [
  //         {
  //           id: mainId,
  //           quantity: 1,
  //           properties: {
  //             _spressoPrice: spressoPrice,
  //           },
  //         },
  //       ],
  //     }),
  //   })
  //     .then((response) => {
  //       if (!response.ok) throw new Error("Something went wrong");
  //       return response.json();
  //     })
  //     .then((data) => {
  //       // Hide loader
  //       if (loader) loader.classList.add("hide");

  //       // Get full cart data after adding item
  //       fetch("/cart.js")
  //         .then((res) => res.json())
  //         .then((cartData) => {
  //           // Update cart with complete cart data including totals
  //           document.dispatchEvent(
  //             new CustomEvent("cart:update", { detail: { cart: cartData } })
  //           );

  //           // Open the cart drawer
  //           document.dispatchEvent(new CustomEvent("cart:open"));
  //         })
  //         .catch((error) => {
  //           console.error("Error fetching cart data:", error);
  //           // Fallback to opening cart without updated data
  //           document.dispatchEvent(new CustomEvent("cart:open"));
  //         });
  //     })
  //     .catch((error) => {
  //       console.error("Error adding to cart:", error);
  //       alert("There was an error adding the item to your cart.");
  //       // Hide loader on error
  //       if (loader) loader.classList.add("hide");
  //     });
  //   return false;
  // }, { capture: true }); // our form submit listener MUST fire first and prevent the default form submission behaviour. If not, Rebuy SmartCart is listening for the form submit event as well and will add duplicate item
});
